const MSG_SUBMIT_ERROR = 'No se ha podido compartir.';
const MSG_SUBMIT_OK = 'Email enviado correctamente.';
const MSG_NAME_ERROR = 'El nombre debe ser de al menos tres caracteres';
const MSG_SENDER_ERROR = 'Tu email debe tener un formato correcto';
const MSG_RECIPIENT_ERROR = 'Su email debe tener un formato correcto';
const MSG_CAPTCHA_ERROR = 'Debes rellenar el captcha';
let $ = Voonto.$;

class Sharemail
{
  
  constructor(selector)
  {
    this.$form = $(selector);
    this.$button = this.$form.find('.boton-form');
    this.sended = false;
  }

  validaEmail(email)
  {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  validaForm(nombre, tu_email, su_email, recaptcha)
  {
    var valid = true;

    var $errName = this.$form.find(".nombre").empty();
    var $errSender = this.$form.find(".tu_email").empty();
    var $errRecipient = this.$form.find(".su_email").empty();
    var $errCaptcha = this.$form.find(".captcha").empty();

    if (nombre.length <= 2) {
      $errName.text(MSG_NAME_ERROR);
      valid = false;
    }

    if (!this.validaEmail(tu_email)) {
      $errSender.text(MSG_SENDER_ERROR);
      valid = false;
    }

    if (!this.validaEmail(su_email)) {
      $errRecipient.text(MSG_RECIPIENT_ERROR);
      valid = false;
    }

    if (recaptcha.length === 0) {
      $errCaptcha.text(MSG_CAPTCHA_ERROR);
      valid = false;
    }

    return valid;
  }

  handleOnsubmit()
  {
    if (this.sended) {
      return false;
    }
    var $msgSubmit = this.$form.find('.enviaremailmsg').empty();
    var nombre = this.$form.find('#tu_nombre').val();
    var tu_email = this.$form.find('#tu_email').val();
    var su_email = this.$form.find('#su_email').val();
    var captcha = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '';

    //Comprobamos que todos los estén rellenos
    if (this.validaForm(nombre, tu_email, su_email, captcha)) {
      var postData = {
        'sender': tu_email,
        'senderName': nombre,
        'recipient': su_email,
        'captcha': captcha,
        'url': window.location.protocol + '//' + window.location.host + window.location.pathname
      };

      Logger.info('send ajax request', postData);
      this.$button.removeClass('btn-azul').addClass('btn-gris');
      this.sended = true;
      $.ajax({
        type: 'post',
        url: "/ajax/v2/sharemail.html",
        data: postData,
        timeout: 20000
      }).fail(function () {
        this.sended = false;
        $msgSubmit.text(MSG_SUBMIT_ERROR);
      }).done(function (data) {
        var msg;
        if (data && data.status === 'ok') {
          msg = MSG_SUBMIT_OK;
        } else if (data && data.message) {
          msg = data.message;
        } else {
          msg = MSG_SUBMIT_ERROR;
        }
        $msgSubmit.text(msg);
        grecaptcha.reset();
      });
    }
    return false;
  }

  clean()
  {
      this.$form.find(".nombre").empty();
      this.$form.find(".tu_email").empty();
      this.$form.find(".su_email").empty();
      this.$form.find(".captcha").empty();
      //this.$form.find('#tu_nombre').val('');
      //this.$form.find('#tu_email').val('');
      this.$form.find('#su_email').val('');
      this.sended = false;
  }

  bind()
  {
    this.$form.on('submit', () => this.handleOnsubmit());
    this.$button.on('click', () => this.handleOnsubmit());
    this.$form.find('.icono.cerrar').on('click', () => {
      this.clean();
      this.$form.hide();
    });
    
    const app = Voonto.getInstance();
    app.load('https://www.google.com/recaptcha/api.js');
  }

  toggle()
  {
    this.$form.toggle();
  }
}

export default Sharemail;


// WEBPACK FOOTER //
// ./src/scripts/article/sharemail.js